module.exports = __webpack_public_path__ + "img/avvisi.651165db.png";